<template>
  <DsDocumentationSection
    tag="Documentación"
    title="Lo que necesitarás durante tus tramites"
    title-id="guia-tramites-documentacion-title"
    description="Reuné esta documentación para que tu proceso avance sin contratiempos."
    :image="documentacionImage"
    image-alt="Persona revisando su documentación"
    :items="documentos"
  />
</template>

<script setup lang="ts">
import documentacionImage from '../../../assets/guia-tramites/doc_imagen.png'
import identificacionIcon from '../../../assets/guia-tramites/ic_doc_identificacion.svg'
import bancoIcon from '../../../assets/guia-tramites/ic_doc_banco.svg'
import fiscalIcon from '../../../assets/guia-tramites/ic_doc_fiscal.svg'
import DsDocumentationSection from '../components/DsDocumentationSection.vue'

const documentos = [
  {
    id: 'identificacion',
    iconSrc: identificacionIcon,
    text: 'Identificación oficial vigente y contratos originales (para incremento o cambio de beneficiarios)'
  },
  {
    id: 'banco',
    iconSrc: bancoIcon,
    text: 'Estado de cuenta bancario no mayor a 3 meses con CLABE (para domiciliación)'
  },
  {
    id: 'fiscal',
    iconSrc: fiscalIcon,
    text: 'Constancia de Situación Fiscal (CSF), comprobante de domicilio y datos fiscales (para facturación)'
  }
]
</script>
